import Cookies from 'universal-cookie';
import { useState } from 'react';
export const getIndivCookie = (cookieName: string): string => {
  const cookies = new Cookies();
  return cookies.get(cookieName) ? cookies.get(cookieName) : '';
};

export const useCookie = (key: string) => {
  const cookies = new Cookies();
  const [item, setItemValue] = useState(() => {
    if (cookies.get(key)) {
      return cookies.get(key);
    }
    return null;
  });

  const setValue = (value: string, options: any) => {
    setItemValue(value);
    cookies.set(key, value, options);
  };

  return [item, setValue];
};
